export function getMessageError(content: { code: string; message: string }) {
  const unknownErrorMessage = 'Unknown error. Please try again later or call customer service.';

  if (content?.message) {
    return content.message;
  } else {
    console.error('Some error came in an unexpected way, note to the developer to handle this.');
    return unknownErrorMessage;
  }
}
